module.exports = __webpack_public_path__ + "media/images/icons/material/handshake-circle-full-19adba59fbfa2ac144fd56a764cf1993.svg";